import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

interface POPdfViewerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  url: string | null;
  title?: string;
}

const POPdfViewerDialog: React.FC<POPdfViewerDialogProps> = ({
  open,
  onOpenChange,
  url,
  title = 'Purchase Order PDF',
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[90vw] w-full h-[85vh] flex flex-col">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 min-h-0">
          {url && (
            <iframe
              src={url}
              className="w-full h-full border-0 rounded"
              title={title}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default POPdfViewerDialog;
